import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { IconSystemSearch } from '@moonpig/launchpad-assets'
import { getSharedButtonStyles } from './getSharedButtonStyles'
import { useLocaleText } from '../locale'
import { ICON_SIZE_PX, SEARCH_FORM_Z_INDEX } from './constants'

const StyledSubmitButton = styled.button<{
  $isSearchOpen: boolean
}>`
  ${({ $isSearchOpen }) => getSharedButtonStyles($isSearchOpen)};
  border-radius: 24px;
  ${s({
    right: 0,
    color: 'colorBlack00',
    bgcolor: 'colorPrimary02',
  })}
  z-index: ${SEARCH_FORM_Z_INDEX};

  &[disabled] {
    background-color: transparent;
  }

  &:not(:disabled):hover {
    opacity: 0.8;
  }
`

type SearchSubmitButtonProps = {
  disabled: boolean
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  isSearchOpen: boolean
}

export const SubmitButton: FC<
  React.PropsWithChildren<SearchSubmitButtonProps>
> = ({ disabled, onClick, isSearchOpen }) => {
  const t = useLocaleText()

  return (
    <StyledSubmitButton
      disabled={disabled}
      onClick={onClick}
      aria-label={t('search.submit_search')}
      type="button"
      $isSearchOpen={isSearchOpen}
    >
      <IconSystemSearch width={ICON_SIZE_PX} height={ICON_SIZE_PX} />
    </StyledSubmitButton>
  )
}
